<nav class="subnav" *ngIf="!!notification">
  <ul class="nav">
    <li class="nav-item" *ngIf="jobId === 0">
      <a class="nav-link active" [routerLink]="['/project/details/', splitProjectNumber(projectId, 0), splitProjectNumber(projectId, 1)]">Zum Projekt</a>
    </li>
    <li class="nav-item" *ngIf="jobId > 0">
      <a class="nav-link active" [routerLink]="['/job/details/', projectId, jobId]" *ngIf="notification.order_pps == 0">Zum Job</a>
      <a class="nav-link active" [routerLink]="['/order/details/', projectId, notification.order_pps]" *ngIf="notification.order_pps > 0">Zur Order</a>
    </li>
  </ul>
</nav>

<main *ngIf="!!notification">
  <h2>Mitteilung {{ projectId }}.0007.{{ notification.notification_id }}</h2>
  <p *ngIf="loading1">
    <span class="label label-light-blue">Mitteilung vom: {{ notification.notification_date | date:'dd.MM.yyyy'  }}</span>
  </p>

  <div class="spinner" *ngIf="loading1">Loading data</div>
  <div class="clr-row" *ngIf="!loading1">
    <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
      <div *ngIf="!!person" class="card">
        <div class="card-header">
          {{ notification.name_project }}
        </div>
        <div class="card-block" *ngIf="!!positions">
          <div class="card-text">
            <clr-tabs>
              <clr-tab>
                <button clrTabLink>Übersicht</button>
                <clr-tab-content clrTabContentId="content1" *clrIfActive="true">
                  <br>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Empfänger
                    </div>
                    <div class="clr-col-8">
                      {{ notification.company_name }}<br />{{ notification.street }}<br />{{ notification.postcode }} {{ notification.city }}
                      <span *ngIf="notification.country !== 'Deutschland'">{{ notification.country }}</span>
                    </div>
                    <div class="clr-col-1">
                      <cds-icon shape="note" [routerLink]="['/contact/details', splitProjectNumber(notification.project_id, 0) ]"></cds-icon>
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Betreff
                    </div>
                    <div class="clr-col-9">
                      {{ notification.subject }}
                    </div>
                  </div>
                  <div class="clr-row">
                    <div class="clr-col-3">
                      Auftrag
                    </div>
                    <div class="clr-col-9">
                      {{ notification.order_id }}
                    </div>
                  </div>
                  <div class="clr-row" *ngIf="!!person[0]">
                    <div class="clr-col-3">
                      Ansprechpartner beim Kunden
                    </div>
                    <div class="clr-col-8">
                      {{ person[0].salutation }} {{ person[0].lastname }}
                    </div>
                    <div class="clr-col-1">
                      <cds-icon shape="note" [routerLink]="['/person/details', person[0].pid ]"></cds-icon>
                    </div>
                  </div>
                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button class="btn" [routerLink]="['/notification/update', notification.project_id, notification.job_id, notification.notification_id]">Mitteilung bearbeiten</button>
                    <button class="btn btn-warning" (click)="deleteNotification(projectId, jobId, notification.notification_id)">Mitteilung löschen</button>
                  </div>

                  <clr-datagrid *ngIf="editPos < 2" [clrDgLoading]="loading2" [(clrDgSelected)]="selected" [clrDgRowSelection]="true">
                    <clr-dg-action-bar *ngIf="(editPos < 2)">
                      <div class="btn-group">
                        <button type="button" class="btn btn-sm btn-danger-outline" (click)="onDelete()" ><cds-icon shape="minus-circle"></cds-icon> Postionen löschen</button>
                      </div>
                    </clr-dg-action-bar>

                    <clr-dg-column [clrDgField]="'position'">Position</clr-dg-column>
                    <clr-dg-column>Anzahl</clr-dg-column>
                    <clr-dg-column [clrDgField]="'name'">Bezeichnung</clr-dg-column>
                    <clr-dg-column [clrDgField]="'technical_drawing'">Zeichnungsnummer</clr-dg-column>
                    <clr-dg-column [clrDgField]="'specification'">Spezifikation</clr-dg-column>
                    <clr-dg-column>Bemerkungen</clr-dg-column>
                    <clr-dg-column *ngIf="editPos > 0"></clr-dg-column>

                    <clr-dg-placeholder>We couldn't find any Position for Notification {{ projectId }}.{{ notification.notification_id }}!</clr-dg-placeholder>
                    <clr-dg-row *clrDgItems="let position of positions; index as i" [clrDgItem]="position">
                      <clr-dg-cell>{{ position.position_label || position.position }}<span *ngIf="position.part > 0">.{{ position.part }}</span> </clr-dg-cell>
                      <clr-dg-cell class="center"><span *ngIf="position.number_of_pieces">{{ position.number_of_pieces }}</span> </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">
                        <b>{{ position.name }}</b>
                        <clr-tooltip *ngIf="position.comment_phm">
                          <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                          <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                            <span>{{ position.comment_phm }}</span>
                          </clr-tooltip-content>
                        </clr-tooltip>
                        <span *ngIf="position.description"><br />{{ position.description }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell [routerLink]="['/component/details', position.technical_drawing]">{{ position.technical_drawing }}</clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.specification">{{ position.specification }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell>
                        <span *ngIf="position.remarks">{{ position.remarks }}<br *ngIf="position.side_agreements" /><br *ngIf="position.side_agreements" /></span>
                        <span *ngIf="position.side_agreements"><b>Nebenabreden (Kunde):</b> {{ position.side_agreements }}</span>
                      </clr-dg-cell>
                      <clr-dg-cell class="btn-group btn-primary btn-icon" minlength="300px" *ngIf="editPos > 0">
                        <button class="btn btn-sm" (click)="updatePositionMode(i, position.position, position.part)">
                          <cds-icon shape="pencil"></cds-icon>
                          <span class="clr-icon-title">Ändern</span>
                        </button>
                      </clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>
                      <clr-dg-pagination #pagination [clrDgPageSize]="50">
                        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Positionen pro Seite</clr-dg-page-size>
                        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
                        von {{positions.length}} Position(en)
                      </clr-dg-pagination>
                    </clr-dg-footer>
                  </clr-datagrid>

                  <app-notification-edit-positions [projectNumber]="projectId" [notificationNumber]="notification.notification_id" [editPosition]="positionId" [editPart]="partId" *ngIf="editPos === 2"  (updatedPosition)="updateNotification($event)"></app-notification-edit-positions>

                  <br />
                  <div class="btn-group btn-sm btn-primary">
                    <button *ngIf="editPos === 0" class="btn" (click)="openPdfPreview()">PDF anzeigen</button>
                    <button *ngIf="editPos === 0" class="btn" (click)="editPos = 1;">Positionen bearbeiten</button>
                    <button *ngIf="editPos > 0" class="btn" (click)="editPos = 0;">Bearbeitung beenden</button>
                  </div>
                </clr-tab-content>
              </clr-tab>

              <clr-tab>
                <button clrTabLink>Dokumente</button>
                <clr-tab-content clrTabContentId="content2" *clrIfActive>
                  <app-notification-details-documents [projectId]="projectId" [jobId]="jobId" [notificationId]="notificationId" [documentType]="notification.notification_type"></app-notification-details-documents>
                </clr-tab-content>
              </clr-tab>
            </clr-tabs>
          </div>
        </div>
        <div class="card-footer">
          <small>Projektverantwortlich:  {{ staffFirstName }} {{ staffLastName }} ({{ notification.employee_phm }})</small>
        </div>
      </div>
    </div>
  </div>
</main>

<clr-modal [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">Mitteilung {{ projectId }}.0007.{{ notificationId }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type=“button” class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="archivePdf(); basic = false">Archivieren</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>


<pre *ngIf="devMode" class="datepicker-output">
    {{ notification | json }}
</pre>
